import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({}),

  mutations: {},

  actions: {
    loadScheduledTrainsByNumberAndDate: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/load-scheduled-trains-by-number-and-date", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadActiveTrainsByScheduleId: (context, request) => {
      return (
        axios
          //TODO
          .post(context.getters.getTmsServiceUrl + "/train/get-active-trains-by-scheduleId", request)
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },

    createTrainsByNumberForInterval: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/train/create-trains-by-number", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    createTrainsByTypeForInterval: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/train/create-trains-by-type", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    updateSaleStartDate: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/alter-train-sale-opening-times", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    // Returns the whole response (not just data) so callers can see the HTTP status and the backend
    // error message. It used to return err.response on failure, and because that object is truthy the
    // screen showed "operation successful" while the real error (e.g. missing role, 403) was hidden.
    updateTrainParameters: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/update-train-parameters", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getTrainParameters: (context, trainIds) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/get-train-parameters", trainIds)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadTrainsLastDayList: (context) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/train/get-trains-last-day-list")
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err;
        });
    },
    postTemporarilyDisableStation: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/temporarily-disable-station", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    trainDelayCompensationRefund: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/train-delay-compensation/refund", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadOccupancyThresholdPasses: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/trains/occupancy-threshold-passes-from-today")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadOccupancyNotificationRecipients: (context, rateId) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/trains/tracked-occupancy-rates/" + rateId + "/recipients")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    saveOccupancyNotificationRecipients: (context, { rateId, emails }) => {
      return axios
        .put(context.getters.getMcServiceUrl + "/trains/tracked-occupancy-rates/" + rateId + "/recipients", { emails })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    sendOccupancyNotification: (context, { rateId, request }) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/trains/tracked-occupancy-rates/" + rateId + "/send-occupancy-notification", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {},
};
